import React from "react";
import { Col, Form } from "react-bootstrap";

/**
 * Reusable select field component
 */
const SelectField = ({
  // Field props
  value,
  onChange,
  name,
  placeholder = "Select...",
  options = [],
  className = "",

  // Validation props
  errors = {},
  validationRules = {},
  jobTypeId,

  // Layout props
  colProps = {},

  // Options props
  valueKey = "value",
  labelKey = "label",

  // Other props
  ...otherProps
}) => {
  const renderErrorMessages = () => {
    const errorMessages = [];

    // Check for validation errors
    Object.entries(validationRules).forEach(([errorKey, condition]) => {
      if (errors[errorKey] && condition) {
        errorMessages.push(
          <p key={errorKey} style={{ color: "red" }}>
            {getErrorMessage(errorKey)}
          </p>
        );
      }
    });

    return errorMessages;
  };

  const getErrorMessage = (errorKey) => {
    const errorMessages = {
      groupError: "Group is required",
      countryError: "Country is required",
      countryStateError: "State/Province is required",
      industryError: "Industry is required",
      joblengthError: "Job length is required",
      travelError: "Travel is required",
    };

    return errorMessages[errorKey] || "Selection is required";
  };

  return (
    <Col {...colProps}>
      <Form.Group controlId={name}>
        <Form.Control
          as="select"
          name={name}
          value={value}
          onChange={onChange}
          className={`inputclass form-control ${className}`}
          {...otherProps}
        >
          {/* <option value="0">{placeholder}</option> */}
          {options.map((option, index) => (
            <option key={index} value={option[valueKey]}>
              {option[labelKey]}
            </option>
          ))}
        </Form.Control>
      </Form.Group>
      {renderErrorMessages()}
    </Col>
  );
};

export default SelectField;
